import storage from 'src/utils/index';

const getAuthString = () => `Bearer ${storage.accessToken.get()}`;

export default getAuthString;
